<template>
  <b-row>
    <b-col v-if="isLoading" size="lg">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row class="mb-2">
        <b-col>
          <div class="btn-group float-left" v-if="ableToEditAgreement">
            <b-button class="btn btn-sm btn-success" @click="updateItem(item)">{{$t('buttons.edit')}}</b-button>
            <b-button class="btn btn-sm btn-warning" @click="archiveItem(item)">{{$t('buttons.archive')}}</b-button>
          </div>
          <div class="float-right">
            <router-link v-if="prevRoute.name === 'EXCMDeviceShow'" :to="{ path: prevRoute.path }" class="btn btn-sm btn-default float-right">{{$t('buttons.backToDevice')}}</router-link>
            <router-link v-else :to="{ name: 'EXCMAgreementList' }" class="btn btn-sm btn-default float-right">
              <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
              <i v-else class="far fa-arrow-alt-left"></i>
            </router-link>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="item">
        <b-col>
          <b-card>
            <span class="h6">{{$t('views.excmagreements.show.title')}}</span>
            <hr class="mb-0 mt-0">
            <div class="card-body">
              <b>{{$t('views.excmagreements.show.agreementNumber')}}:</b> {{ item['agreementNumber'] }}<br>
              <b>{{$t('views.excmagreements.show.dateFrom')}}:</b> {{ item['dateFrom'] }}<br>
              <b>{{$t('views.excmagreements.show.dateTo')}}:</b> {{ item['dateTo'] }}<br>
              <b>{{$t('views.excmagreements.show.company')}}:</b> {{ item['company'].firmname1 }}
            </div>
          </b-card>
        </b-col>
        <b-col>
          <b-card>
            <span class="h6">{{$t('views.excmagreements.show.agreementConsents')}}</span>
            <hr class="mb-0 mt-0">
            <div class="card-body">
              <div v-if="item.agreementConsents.length === 0">
                {{$t('views.excmagreements.show.agreementConsent.noConsents')}}
              </div>
              <div v-else v-for="(agreementConsent, index) in item.agreementConsents" v-bind:key="'agreementConsent-' + index">
                <div class="float-left">
                  <h5>#{{index + 1}}</h5>
                </div>
                <div class="float-left ml-3">
                  <p class="m-0">
                    <b>{{$t('views.excmagreements.show.agreementConsent.title')}}:</b> {{ agreementConsent.consent.title }}<br>
                    <b>{{$t('views.excmagreements.show.agreementConsent.agree')}}:</b> <span v-if="agreementConsent.agree === 0">{{ $t('buttons.no') }}</span><span v-else-if="agreementConsent.agree === 1">{{ $t('buttons.yes') }}</span>
                  </p>
                  <b-row v-if="ableToEditAgreement">
                    <b-col>
                      <b-button class="btn btn-success" size="sm" @click="updateAgreementConsent(agreementConsent)">{{$t('buttons.edit')}}</b-button>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="item">
        <b-col>
          <b-card>
            <button v-if="ableToEditAgreement" type="button" class="mb-1 mr-1 btn btn-info btn-circle btn-sm fa fa-plus fa-lg" v-b-tooltip.hover :title="$t('buttons.addAgreementDevice')" @click="addAgreementDevice()">
            </button>
            <span class="h6">{{$t('views.excmagreements.show.agreementDevices')}}</span>
            <hr class="mt-0 mb-0">
            <div class="card-body">
              <b-row v-if="item.agreementDevices.length === 0">
                <b-col>
                  {{$t('views.excmagreements.show.agreementDevice.noDevices')}}
                </b-col>
              </b-row>
              <b-row v-else>
                <b-col>
                  <b-row v-for="(agreementDevice, index) in item.agreementDevices" v-bind:key="'agreementDevice-' + index">
                    <b-col>
                      <b-row v-if="index !== 0">
                        <b-col>
                          <hr class="mt-2 mb-2">
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="float-left">
                            <h5>#{{index + 1}}</h5>
                          </div>
                          <div class="float-left ml-3">
                            <p class="m-0">
                              <b>{{$t('views.excmagreements.show.agreementDevice.deviceName')}}:</b> {{ agreementDevice.device.idDeviceModel.model }}<br>
                              <b>{{$t('views.excmagreements.show.agreementDevice.deviceBrand')}}:</b> {{ agreementDevice.device.idDeviceModel.idDeviceBrand.brandTitle }}<br>
                              <b>{{$t('views.excmagreements.show.agreementDevice.deviceType')}}:</b> {{ agreementDevice.device.idDeviceModel.idDeviceType.title }}<br>
                              <b>{{$t('views.excmagreements.show.agreementDevice.serialNumber')}}:</b> {{ agreementDevice.device.serialNumber }}
                            </p>
                            <b-row v-if="ableToEditAgreement">
                              <b-col>
                                <b-button class="btn btn-success" size="sm" @click="updateAgreementDevice(agreementDevice)">{{$t('buttons.edit')}}</b-button>
                                <b-button class="btn btn-danger" size="sm" @click="deleteItem(agreementDevice)">{{$t('buttons.delete')}}</b-button>
                              </b-col>
                            </b-row>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="item">
        <b-col>
          <b-card>
            <button v-if="ableToEditAgreement" type="button" class="mb-1 mr-1 btn btn-info btn-circle btn-sm fa fa-plus fa-lg" v-b-tooltip.hover :title="$t('buttons.addAgreementSla')" @click="addAgreementSla()">
            </button>
            <span class="h6">{{$t('views.excmagreements.show.agreementSlas')}}</span>
            <hr class="mt-0 mb-0">
            <div class="card-body">
              <b-row v-if="item.agreementSlas.length === 0">
                <b-col>
                  {{$t('views.excmagreements.show.agreementSla.noSlas')}}
                </b-col>
              </b-row>
              <b-row v-else v-for="(agreementSla, index) in item.agreementSlas" v-bind:key="'agreementSla-' + index">
                <b-col>
                  <b-row v-if="index !== 0">
                    <b-col>
                      <hr class="mt-2 mb-2">
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <div class="float-left">
                        <h5>#{{index + 1}}</h5>
                      </div>
                      <div class="float-left ml-3">
                        <p>
                          <b>{{$t('views.excmagreements.show.agreementSla.title')}}:</b> {{ agreementSla.sla.title }}
                        </p>
                        <b-row v-if="ableToEditAgreement">
                          <b-col>
                            <b-button class="btn btn-success" size="sm" @click="updateAgreementSla(agreementSla)">{{$t('buttons.edit')}}</b-button>
                            <b-button class="btn btn-danger" size="sm" @click="deleteItem(agreementSla)">{{$t('buttons.delete')}}</b-button>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="item">
        <b-col>
          <b-card>
            <button v-if="ableToEditAgreement" type="button" class="mb-1 mr-1 btn btn-info btn-circle btn-sm fa fa-plus fa-lg" v-b-tooltip.hover :title="$t('buttons.addAgreementCyclicTask')" @click="addAgreementCyclicTask()">
            </button>
            <span class="h6">{{$t('views.excmagreements.show.agreementCyclicTasks')}}</span>
            <hr class="mt-0 mb-0">
            <div class="card-body">
              <b-row v-if="item.agreementCyclicTasks.length === 0">
                <b-col>
                  {{$t('views.excmagreements.show.agreementCyclicTask.noCyclicTasks')}}
                </b-col>
              </b-row>
              <b-row v-else v-for="(agreementCyclicTask, index) in item.agreementCyclicTasks" v-bind:key="'agreementCyclicTask-' + index">
                <b-col>
                  <b-row v-if="index !== 0">
                    <b-col>
                      <hr class="mt-2 mb-2">
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <div class="float-left">
                        <h5>#{{index + 1}}</h5>
                      </div>
                      <div class="float-left ml-3">
                        <p>
                          <b>{{$t('views.excmagreements.show.agreementCyclicTask.taskType')}}:</b> {{ agreementCyclicTask.taskType.title }}<br>
                          <b>{{$t('views.excmagreements.show.agreementCyclicTask.daysInterval')}}:</b> {{ agreementCyclicTask.daysInterval }}<br>
                          <b>{{$t('views.excmagreements.show.agreementCyclicTask.dateFrom')}}:</b> {{ agreementCyclicTask.dateFrom }}<br>
                          <b>{{$t('views.excmagreements.show.agreementCyclicTask.dateTo')}}:</b> {{ agreementCyclicTask.dateTo }}
                        </p>
                        <b-row v-if="ableToEditAgreement">
                          <b-col>
                            <b-button class="btn btn-success" size="sm" @click="updateAgreementCyclicTask(agreementCyclicTask)">{{$t('buttons.edit')}}</b-button>
                            <b-button class="btn btn-danger" size="sm" @click="deleteItem(agreementCyclicTask)">{{$t('buttons.delete')}}</b-button>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <UpdateAgreementModal></UpdateAgreementModal>
      <UpdateAgreementDeviceModal></UpdateAgreementDeviceModal>
      <CreateAgreementDeviceModal></CreateAgreementDeviceModal>
      <UpdateAgreementConsentModal></UpdateAgreementConsentModal>
      <UpdateAgreementSlaModal></UpdateAgreementSlaModal>
      <CreateAgreementSlaModal></CreateAgreementSlaModal>
      <CreateCyclicTaskModal></CreateCyclicTaskModal>
      <UpdateCyclicTaskModal></UpdateCyclicTaskModal>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles.js'
import getId from '@/utils/getIdFromLink'
import UpdateAgreementModal from './components/UpdateAgreementModal'
import UpdateAgreementDeviceModal from '../excmagreementdevice/components/UpdateAgreementDeviceModal'
import CreateAgreementDeviceModal from '../excmagreementdevice/components/CreateAgreementDeviceModal'
import UpdateAgreementConsentModal from '../excmagreementconsent/components/UpdateAgreementConsentModal'
import UpdateAgreementSlaModal from '../excmagreementsla/components/UpdateAgreementSlaModal'
import CreateAgreementSlaModal from '../excmagreementsla/components/CreateAgreementSlaModal'
import Loader from '../../Layout/Loader'
import CreateCyclicTaskModal from '../excmcyclictask/components/CreateCyclicTaskModal'
import UpdateCyclicTaskModal from '../excmcyclictask/components/UpdateCyclicTaskModal'

export default {
  computed: {
    ...mapGetters({
      deleteError: 'excmagreement/del/error',
      error: 'excmagreement/show/error',
      isLoading: 'excmagreement/show/isLoading',
      item: 'excmagreement/show/retrieved'
    }),
    mobileView () {
      return this.$store.state.mobileView
    },
    agreementUpdated () {
      return this.$store.state.modals.excmagreement.update.updated
    },
    agreementConsentUpdated () {
      return this.$store.state.modals.excmagreementconsent.update.updated
    },
    agreementDeviceUpdated () {
      return this.$store.state.modals.excmagreementdevice.update.updated
    },
    agreementDeviceCreated () {
      return this.$store.state.modals.excmagreementdevice.create.created
    },
    agreementCyclicTaskUpdated () {
      return this.$store.state.modals.excmcyclictask.update.updated
    },
    agreementCyclicTaskCreated () {
      return this.$store.state.modals.excmcyclictask.create.created
    },
    ableToEditAgreement () {
      return this.checkRoles('agreements', 'EXCMAgreementUpdate')
    }
  },

  components: {
    UpdateAgreementModal,
    UpdateAgreementDeviceModal,
    CreateAgreementDeviceModal,
    UpdateAgreementConsentModal,
    UpdateAgreementSlaModal,
    CreateAgreementSlaModal,
    Loader,
    CreateCyclicTaskModal,
    UpdateCyclicTaskModal
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  beforeDestroy () {
    this.reset()
  },

  beforeCreate () {
    checkPagePermission('agreements', 'EXCMAgreementShow')
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  data () {
    return {
      prevRoute: ''
    }
  },

  watch: {
    agreementUpdated: function (change) {
      if (change === 1) {
        this.item = {}
        this.retrieve(decodeURIComponent(this.$route.params.id))
        this.$store.state.modals.excmagreement.update.updated = 0
      }
    },
    agreementDeviceCreated: function (change) {
      if (change === 1) {
        this.item = {}
        this.retrieve(decodeURIComponent(this.$route.params.id))
        this.$store.state.modals.excmagreementdevice.create.created = 0
      }
    },
    agreementConsentUpdated: function (change) {
      if (change === 1) {
        this.item = {}
        this.retrieve(decodeURIComponent(this.$route.params.id))
        this.$store.state.modals.excmagreementconsent.update.updated = 0
      }
    },
    agreementDeviceUpdated: function (change) {
      if (change === 1) {
        this.item = {}
        this.retrieve(decodeURIComponent(this.$route.params.id))
        this.$store.state.modals.excmagreementdevice.update.updated = 0
      }
    },
    agreementCyclicTaskUpdated: function (change) {
      if (change === 1) {
        this.item = {}
        this.retrieve(decodeURIComponent(this.$route.params.id))
        this.$store.state.modals.excmcyclictask.update.updated = 0
      }
    },
    agreementCyclicTaskCreated: function (change) {
      if (change === 1) {
        this.item = {}
        this.retrieve(decodeURIComponent(this.$route.params.id))
        this.$store.state.modals.excmcyclictask.create.created = 0
      }
    },
    item: function (itemShow) {
      itemShow.dateFrom = this.$moment(itemShow.dateFrom).format('YYYY-MM-DD')
      itemShow.dateTo = this.$moment(itemShow.dateTo).format('YYYY-MM-DD')
      for (let i in itemShow.agreementCyclicTasks) {
        if (itemShow.agreementCyclicTasks[i].dateFrom) {
          itemShow.agreementCyclicTasks[i].dateFrom = this.$moment(itemShow.agreementCyclicTasks[i].dateFrom).format('YYYY-MM-DD')
        }
        if (itemShow.agreementCyclicTasks[i].dateTo) {
          itemShow.agreementCyclicTasks[i].dateTo = this.$moment(itemShow.agreementCyclicTasks[i].dateTo).format('YYYY-MM-DD')
        }
      }
    }
  },

  methods: {
    ...mapActions({
      del: 'excmagreement/del/del',
      reset: 'excmagreement/show/reset',
      retrieve: 'excmagreement/show/retrieve'
    }),

    archiveItem (item) {
      this.$http
        .put('api/e_x_c_m_agreements/' + this.getIdLink(this.item['@id']), {
          state: 0
        })
        .then(response => {
          this.$router.push({ name: 'EXCMAgreementList' })
          this.$Swal({ // show notification with success
            type: 'success',
            title: this.$t('notifications.update.updatedTitle'),
            showConfirmButton: false,
            timer: 2500
          })
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },

    addAgreementDevice () {
      this.$store.state.modals.excmagreementdevice.create.show = 1
      this.$store.state.modals.excmagreementdevice.create.agreementIRI = this.item['@id']
    },

    addAgreementCyclicTask () {
      this.$store.state.modals.excmcyclictask.create.show = 1
      this.$store.state.modals.excmcyclictask.create.agreement = this.item
    },

    updateAgreementCyclicTask (cyclicTask) {
      this.$store.state.modals.excmcyclictask.update.cyclicTask = cyclicTask
      this.$store.state.modals.excmcyclictask.update.show = 1
    },

    updateAgreementDevice (devicePivot) {
      this.$store.state.modals.excmagreementdevice.update.devicePivot = devicePivot
      this.$store.state.modals.excmagreementdevice.update.show = 1
    },

    updateAgreementConsent (consentPivot) {
      this.$store.state.modals.excmagreementconsent.update.consentPivot = consentPivot
      this.$store.state.modals.excmagreementconsent.update.show = 1
    },

    addAgreementSla () {
      this.$store.state.modals.excmagreementsla.create.show = 1
      this.$store.state.modals.excmagreementsla.create.agreementIRI = this.item['@id']
    },

    updateAgreementSla (slaPivot) {
      this.$store.state.modals.excmagreementsla.update.slaPivot = slaPivot
      this.$store.state.modals.excmagreementsla.update.show = 1
    },

    updateItem (item) {
      this.$store.state.modals.excmagreement.update.agreement = item
      this.$store.state.modals.excmagreement.update.show = 1
    },

    deleteItem (item) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        text: this.$t('notifications.deleteDescription'),
        type: 'warning',
        showCancelButton: true,
        // confirmButtonColor: '#3085d6',
        // cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then(response => {
        this.del(item).then(() => this.retrieve(decodeURIComponent(this.$route.params.id)))
        this.$Swal({
          title: this.$t('notifications.deletedTitle'),
          type: 'success'
        })
      })
      // if (window.confirm('Are you sure you want to delete this item?')) {
      //   this.del(item).then(() => this.$router.push({ name: 'EXCMAgreementList' }))
      // }
    },

    getIdLink (link) {
      return getId(link)
    },

    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    }
  }
}
</script>
